/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Debounce from "../../../../CommonMethods/Debounce";
// import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick";

export default function SubdivisionDropdownWithSearch({
    label,
    id,
    placeholder,
    value,
    disabled,
    emptyField,
    subdivisionData,
    setQueryParams,
    selectedSubdivisionName,
    setisOpensub,
    isOpensub,
    subdivisionloadingstatus,
    handleSelectionSubdivision,
    loading,
    isMonitor
}
) {
    const ref = useRef();
    const location = useLocation()
    const dispatch = useDispatch()
    const [displayEmptyMsg, setDisplayEmptyMsg] = useState('')
    const [skip, setSkip] = useState(false)
    const [suggestions, setSuggestions] = useState('')
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const [searchvalue, setsearchvalue] = useState('')
    const [isOpenSubDiv, setIsOpenSubDiv] = useState(false)


    const handleChange = (val) => {
        if (val.trim() !== '') {
            setQueryParams(`search=${encodeURIComponent(val.trim())}`)

        }
        else {
            setQueryParams('')
        }
    }
    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        []
    );

    // useOnClickOutside(ref, () => {
    //     setisOpensub(false)
    // })

    useEffect(() => {
        if (subdivisionData !== undefined) {
            if (subdivisionData?.data?.length === 0) {
                setDisplayEmptyMsg('No results found.')
                return
            }
            setDisplayEmptyMsg('')
        }
    }, [subdivisionData])
    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
  effect is triggered when the `isOpenSubDiv` state variable changes. */
    useEffect(() => {
        if (subdivisionData?.data?.length === 0) {
            setDisplayEmptyMsg('No results found')
        } else {
            setDisplayEmptyMsg('')
        }
        if (isOpensub) {
            setDisplayEmptyMsg('')
            optimizedFn('')
            setSuggestions('')
        }
    }, [isOpenSubDiv])

    return (
        <>
            <div className='relative' ref={ref}>
                <label htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                <button
                    ref={buttonRef}
                    onClick={() => { setisOpensub(!isOpensub); setIsOpenSubDiv(!isOpenSubDiv) }}
                    className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA] '}  disabled:bg-[#E7EAF4] rounded-lg px-3.5 py-[11px] text-base font-normal 
                    text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                    disabled={disabled}
                    id={'subdivision_button'}
                >
                    <p id={id} className={`${(selectedSubdivisionName.subdivision_name === "" || selectedSubdivisionName.subdivision_name === undefined) ? 'text-[#52555D] ' : 'text-[#000B17] '}text-start text-sm more-lines`}>{(selectedSubdivisionName.subdivision_name === "" || selectedSubdivisionName.subdivision_name === undefined)
                        ? placeholder
                        : selectedSubdivisionName.subdivision_name || selectedSubdivisionName}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpensub ? "transform rotate-180" : ""}`} />
                </button>
                <ul className={`py-4 pr-1 pl-4 rounded-lg bg-white z-[99] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpensub ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <ul>
                            <li>
                                <div className="relative pr-3">
                                    <label htmlFor=""></label>
                                    <input
                                        type="text"
                                        autoComplete={"off"}
                                        id={isMonitor !== undefined ? 'search-value-subdivision' : "search-value"}
                                        placeholder="Search by sub division name"
                                        className="border border-[#C5C9DA]  rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none"
                                        onChange={e => { setSuggestions(e.target.value); optimizedFn(e.target.value) }}
                                        value={suggestions} />
                                    <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3" />
                                </div>
                            </li>
                        </ul>
                        {(subdivisionloadingstatus === 'pending') &&
                            <div className='flex justify-center items-center mb-[40px] mt-[90px]'>
                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  mt-[-45px] spin-animation"></div>
                            </div>
                        }
                        {subdivisionloadingstatus === 'fulfilled' && displayEmptyMsg === "" ?
                            <ul className={`max-h-[440px] overflow-auto scrollbar_gray pr-3`}>
                                {subdivisionData !== undefined && subdivisionData !== null && subdivisionData.data.map((item, i) => (
                                    <li key={item._id} className='flex justify-between items-center p-2'>
                                        <div className="">
                                            <p
                                                id={`${isMonitor !== undefined ? i + 'subdivision' : 'option-sub-division'}`}
                                                data-testid={i + 'subdropdown'}
                                                onClick={() => handleSelectionSubdivision(item)}
                                                title={isMonitor === undefined ? item?.subdivision_name : item?.subdivision_name}
                                                htmlFor={i}
                                                className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines"
                                            >{item?.subdivision_id + " " + item?.subdivision_name}</p>

                                        </div>
                                    </li>
                                ))}

                            </ul> :
                            <p className="mt-2 text-center">{subdivisionloadingstatus === 'pending' ? "" : displayEmptyMsg}</p>}
                    </li>

                </ul>
            </div>
        </>
    )
}
